import React, { createContext, useContext, useEffect, useState } from 'react';
import { isAuthenticated, redirectToLogin, redirectToLogout } from './proxy-fetch';

type AuthApi = {
  authenticated: boolean;
  logIn: () => void;
  logOut: (url?:string) => void;
};

function useAuthApi(): AuthApi {
  const [authenticated, setAuthenticated] = useState<boolean>(false);

  useEffect(() => {
    isAuthenticated(true).then((a) => setAuthenticated(a));
    document.onvisibilitychange = () => {
      if (document.visibilityState === 'visible') {
        isAuthenticated(true).then((a) => setAuthenticated(a));
      }
    };
  }, []);

  return {
    authenticated,
    logIn: redirectToLogin,
    logOut: redirectToLogout,
  };
}

export const AuthContext = createContext<AuthApi | null>(null);
export const AuthProvider = ({
  children,
}: {
  children: React.ReactElement;
}) => {
  const api = useAuthApi();
  return <AuthContext.Provider value={api}>{children}</AuthContext.Provider>;
};

export const useAuthContext = (): AuthApi => {
  return useContext(AuthContext) as AuthApi;
};
